import { render, staticRenderFns } from "./TSZ_ComparativaNueva.vue?vue&type=template&id=076c8492&scoped=true&"
import script from "./TSZ_ComparativaNueva.vue?vue&type=script&lang=js&"
export * from "./TSZ_ComparativaNueva.vue?vue&type=script&lang=js&"
import style0 from "./TSZ_ComparativaNueva.vue?vue&type=style&index=0&id=076c8492&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "076c8492",
  null
  
)

export default component.exports